<script setup lang="ts">
import { ExchangeRateSkeleton } from '~/components/ui/exchange-rate'
</script>

<template>
  <section
    class="relative flex h-20 flex-col items-center space-y-5 rounded-lg bg-gray-100 p-4 sm:flex-row sm:justify-between sm:space-x-8 sm:space-y-0"
  >
    <div class="flex w-full justify-between">
      <!-- 4 currency skeletons -->
      <ExchangeRateSkeleton v-for="i in 4" :key="`skeleton-${i}`" />
    </div>

    <!-- Button skeleton -->
    <div class="h-6 w-24 animate-pulse rounded bg-gray-300 md:ml-auto" />
  </section>
</template>
